<template>
  <teleport to="body">
    <div
      v-if="isOpen"
      id="confirmModal"
      class="modal-alert show-alert"
      role="dialog"
      aria-modal="true"
    >
      <div class="modal-wrap-alert" @click.self="onCancel">
        <div class="modal-content-alert">
          <h2>
            <template v-for="(line, idx) in normalizedTitleLines" :key="idx">
              {{ line }}<br v-if="idx < normalizedTitleLines.length - 1" />
            </template>
          </h2>
          <p v-if="message">
            <span v-for="(line, idx) in normalizedLines" :key="idx"> {{ line }}<br /> </span>
          </p>
          <div class="alert-button-group">
            <button class="button-secondary" @click="onCancel">
              <span>
                <img src="../../assets/images/icon/icon_closeX_black.svg" alt="" />
              </span>
              {{ cancelText }}
            </button>
            <button class="delete" @click="onConfirm">
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  isOpen: boolean
  title: string
  message?: string | string[]
  cancelText?: string
  confirmText?: string
}>()

const emit = defineEmits<{
  (e: 'cancel'): void
  (e: 'confirm'): void
}>()

const normalizedTitleLines = computed(() => (props.title ? props.title.split('\n') : []))

const normalizedLines = computed(() =>
  Array.isArray(props.message) ? props.message : props.message ? props.message.split('\n') : [],
)

const onCancel = () => emit('cancel')
const onConfirm = () => emit('confirm')
</script>
